import { render, staticRenderFns } from "./object-position.vue?vue&type=template&id=5dce3618&"
import script from "./object-position.vue?vue&type=script&lang=js&"
export * from "./object-position.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports